import { cartablanca } from './cartablanca';
import { tecate } from './tecate';
import { promohub } from './promohub';
import { matchpaint } from './matchpaint';
import { fabs } from './fabs';
import { indio } from './indio';
import { cristal } from './cristal';

export const Texts = { tecate, promohub, matchpaint, fabs, cartablanca, indio, cristal }